import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';

import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import Input from '@mui/material/Input';
import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';
import SearchIcon from '@mui/icons-material/Search';

import SearchSuggestions from 'components/SearchSuggestions/SearchSuggestions';
import { searchData } from 'store/search-actions';
import { getLinkLtik } from 'constants/LTIData';

import classes from './Search.module.css';

const url = window.location.pathname.split('/');

const Search = () => {
  const { t } = useTranslation(['header']);
  const dispatch = useDispatch();
  const dataAcademy = useSelector(state => state.academyInfo);
  const searchContent = useSelector(state => state.searchInfo);
  const [typingTimeout, setTypingTimeout] = useState(0);
  const [openMenu, setOpenMenu] = useState(false);
  const { register, handleSubmit, watch, reset } = useForm();
  let searchText = watch('searchText', false);

  useEffect(() => {
    if (searchText.length > 0) {
      if (typingTimeout) clearTimeout(typingTimeout);
      setTypingTimeout(
        setTimeout(() => {
          setOpenMenu(true);
          const privateAcademy =
            dataAcademy.data.productType === 2 ||
            dataAcademy.data.productType === 4
              ? true
              : false;
          dispatch(
            searchData(
              searchText,
              dataAcademy.data.shortName,
              privateAcademy,
              dataAcademy.data.idAcademy
            )
          );
        }, 800)
      );
    }
  }, [dataAcademy, searchText]);

  const closeMenu = () => {
    setOpenMenu(false);
    reset({ searchText: '' });
  };

  // eslint-disable-next-line no-console
  const onSubmit = data => console.log(data);

  return (
    <div className={classes.searchContainer}>
      <Button
        component={Link}
        to={url[2] === 'a' ? '/a' : '/'}
        className={classes.homeBtn}
        disabled={getLinkLtik()}
      >
        <figure className={classes.homeIcon}>
          <img
            className={classes.img}
            src="https://d1g6c01s9ssd7h.cloudfront.net/img/mayahiiLogoM.png"
            alt="homeIcon"
          />
        </figure>
      </Button>
      <form
        onSubmit={handleSubmit(onSubmit)}
        className={classes.searchForm}
      >
        <Input
          placeholder={t('search_bar')}
          fullWidth
          className={classes.inputForm}
          disableUnderline
          {...register('searchText')}
        />
        <IconButton className={classes.btnSearch} type="submit">
          <SearchIcon className={classes.iconSearch} />
        </IconButton>
      </form>
      {/* {searchContent.data.response && (
        <SearchSuggestions
          searchText={searchText}
          searchInfo={searchContent}
          openMenu={openMenu}
          closeMenu={closeMenu}
        />
      )} */}
      <SearchSuggestions
        searchText={searchText}
        searchInfo={searchContent}
        openMenu={openMenu}
        closeMenu={closeMenu}
      />
    </div>
  );
};

export default Search;
